import { type Translator, TranslationHint, Shop, Connector, Price, Count, CheckoutEvents } from "@ticketmachine/sdk";
import { derived } from "svelte/store";
import { createConnector } from "@/cart/sdk";
import { URLS, resolveDefaultURLS } from "@/cart/sdk/urls";
import { setCartLoaded } from "@frontend/cart";
import { _, PriceValue } from "@frontend/translations";

const prefix = (() => {
    const raw = new URL(window.location as any);
    raw.pathname = "ajax";
    raw.search = "";
    raw.hash = "";
    return raw.toString()
})();
const urls: URLS = resolveDefaultURLS((...segments: []) => {
    return [prefix, ...segments].join("/");
});



(async () => {
    const shop = await Shop.create({
        onError: (e) => window.reportError(e),
        connector: {
            ...await createConnector("webshop", urls),

            mountCheckout(target: HTMLElement, events: CheckoutEvents): (() => void)|null {
                let cancelled = false;
                let unmounter = () => {}

                (async () => {
                    const checkout = (await import("./checkout")).default;
                    if (cancelled) return;
                    unmounter = checkout(target, events);
                })().catch(window.reportError);

                return () => {
                    cancelled = true;
                    unmounter();
                    unmounter = () => {}
                }
            }
        } as Connector,
        translator: derived(_, $_ => {
            return ((key: string, values: any = {}, names: string[] = []) => {
                const rawValues = names.map(n => values[n]);
                const stringified = rawValues.map(v => {
                    if (v instanceof Price) {
                        return new PriceValue(v.amount);
                    } else if (v instanceof Count) {
                        return v.value;
                    } else if (v instanceof TranslationHint) {
                        return v.toLocaleString((window as any).I18n.config.language_code);
                    } else if (typeof v === "number") {
                        return v;
                    } else {
                        return v?.toString();
                    }
                });
                return $_(key, stringified, names);
            }) as Translator<any>;
        })
    });
    (window as any)["Shop"] = shop;
    setCartLoaded();
})().catch(window.reportError)
